/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoFlushException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown if flush() is not implemented
 */
let NoFlushException = exports.NoFlushException = function (_Exception) {
  _inherits(NoFlushException, _Exception);

  function NoFlushException() {
    _classCallCheck(this, NoFlushException);

    return _possibleConstructorReturn(this, (NoFlushException.__proto__ || Object.getPrototypeOf(NoFlushException)).call(this, 'Flush is not implemented for this driver'));
  }

  return NoFlushException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/Exception/NoFlushException.js
// module id = 351
// module chunks = 0